import { useState } from "react";
import SectionTitle from "@/components/base/SectionTitle";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20" aria-labelledby="home-faq-title">
      <div className="max-w-4xl mx-auto">
        <SectionTitle
          eyebrow="FAQ"
          title="常见问题"
          desc="关于内容范围、更新方式与浏览方式，先把最常被问到的几点说清楚。"
        />
        <div className="flex flex-col gap-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className="border border-background-200 rounded-lg overflow-hidden bg-background-50"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                    aria-expanded={open}
                  >
                    <span className="font-heading text-base font-bold text-foreground-900">
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-lg text-primary-600 ${
                        open ? "ri-subtract-line" : "ri-add-line"
                      }`}
                      aria-hidden="true"
                    />
                  </button>
                </h3>
                {open && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <p className="text-sm text-foreground-600 mt-8 text-center">
          还有其他疑问？
          <Link to="/contact" className="text-primary-700 hover:text-primary-600 ml-1 transition-colors">
            联系我们
          </Link>
          提交你的问题。
        </p>
      </div>
    </section>
  );
}